import React, { Component } from 'react';
import { Data } from '../Data';
import { DateUtils } from '../DateUtils'
import { Input } from 'reactstrap';
import ToolTip from 'react-tooltip-lite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class Verify extends Component {
    constructor(props) {
        super(props);
        this.dataService = new Data();
        this.dateUtils = new DateUtils();
        this.postVerify = this.postVerify.bind(this);        

        this.state = {
            pin: '',
            ssn: '',
            dateofbirth: '',
            zipcode: '',
            districtno: -1,
            districts: [],
            submitted: false,
            message: ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.getDistricts = this.getDistricts.bind(this);
        this.getDistricts();
    }

    handleChange(e) {
            const { name, value } = e.target;
            this.setState({ [name]: value });
    }

    getDistricts() {
        if (this.state.districts.length === 0) {
            this.dataService.getAllDistricts()
                .then((data) => {
                    if (data) {
                        this.setState({ districts: data })
                    }
                    else {
                        this.setState({ message: 'Failed to get the districts' });
                    }
                },
                () => {
                    // no op;
                });
        }
    }

    buildDistrictOptions() {
        var districtOptions = [];
        districtOptions.push(
            <option disabled key={-1} value={-1}>Select a district</option>
        )

        for (let i = 0; i < this.state.districts.length; i++) {
            districtOptions.push(
                <option key={this.state.districts[i].number} value={this.state.districts[i].number}>
                    {this.state.districts[i].name}
                </option>
            )
        }
        return (districtOptions);
    }

    postVerify(e) {
        e.preventDefault();
        this.setState({ submitted: true });
        const { pin, ssn, dateofbirth, zipcode, districtno } = this.state;
        if (pin && ssn && dateofbirth && zipcode && (districtno!==-1)) {
            this.dataService.postVerify(pin, ssn, this.dateUtils.formatDate(dateofbirth, 'yyyy-MM-dd'), zipcode, districtno)
                .catch((msg) => {
                    const text = msg.message;
                    this.setState({ message: text });
                });
        }
    }

    render() {
        const { pin, ssn, dateofbirth, zipcode, submitted, message, districtno, districts } = this.state;

        return (
            <div>
                <h4>Member Verification</h4>
                <form name="form" onSubmit={this.postVerify}>
                    <div className='login-form-container'>
                        <label className='login-form-label'>PIN</label>
                        <input
                            placeholder="PIN"
                            type="text"
                            className={'form-control' + (submitted && !pin ? ' has-error' : '') + ' login-form-text'}
                            name="pin"
                            value={pin}
                            onChange={this.handleChange}
                            title="PIN text box"
                        />
                        {submitted && !pin &&
                            <div className="help-block">PIN is required</div>
                        }

                        <label className='login-form-label'>SSN</label>
                        <input
                            placeholder="9 digits, no dashes or spaces"
                            type="text"
                            className={'form-control' + (submitted && !ssn ? ' has-error' : '') + ' login-form-text'}
                            name="ssn"
                            value={ssn}
                            pattern="[0-9]{9}"
                            maxLength="9"
                            title="Social security number text box"
                            onChange={this.handleChange}
                        />
                        {submitted && !ssn &&
                            <div className="help-block">Social Security Number is required</div>
                        }

                        <label className='login-form-label'>BIRTHDATE</label>
                        <ToolTip
                            content={(
                                <p className="tip-heading">
                                    <strong>*Safari users only:</strong> Please ensure to enter the date <br />
                                    in the following format: yyyy-MM-dd. e.g. 1980-12-25
                                </p>
                            )}
                            direction="right"
                            tagName="span"
                            className="target"
                            tipContentClassName="tip-container">
                            <FontAwesomeIcon icon='info-circle' />
                        </ToolTip>
                        <input
                            placeholder="yyyy-MM-dd"
                            type="date"
                            className={'form-control' + (submitted && !dateofbirth ? ' has-error' : '') + ' login-form-text textbox-n'}
                            name="dateofbirth"
                            value={dateofbirth}
                            onChange={this.handleChange}
                            title="Date of birth text box"
                        />
                        {submitted && !dateofbirth &&
                            <div className="help-block">Date of birth is required</div>
                        }

                        <label className='login-form-label'>ZIP</label>
                        <input
                            placeholder="Zip (Mailing Address)"
                            type="text"
                            className={'form-control' + (submitted && !zipcode ? ' has-error' : '') + ' login-form-text'}
                            name="zipcode"
                            value={zipcode}
                            maxLength="5"
                            pattern="[0-9]{5}"
                            title="Zip code text box"
                            onChange={this.handleChange}
                        />
                        {submitted && !zipcode &&
                            <div className="help-block">Zip code is required</div>
                        }

                        <label className='login-form-label'>DISTRICT</label>
                        <Input type="select"
                            className={'form-control' + (submitted && (districtno === -1) ? ' has-error' : '') + ' login-form-text'}
                            onChange={this.handleChange}
                            name="districtno"
                            value={districtno}
                            key={districts}>
                            {this.buildDistrictOptions()}
                        </Input>
                        {submitted && (districtno === -1) &&
                            <div className="help-block">District is required</div>
                        }
                    </div>
                    <div className="form-group">
                        <button className="btn btn-primary login-button" title="Button to verify membership">Verify</button>
                        <a href="/Login" title="Link to cancel creation of member">Cancel</a>
                    </div>
                </form>
                {message && <div className="help-block">{message}</div>}
            </div>
        );
    }
}
